import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Http} from '@angular/http';
// service
import {UserService} from '../service/user.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {
  currentUser: any;
  password: string;
  passwordconfirm: string;
  public showError: boolean;
  public errorMessage: string;

  constructor(private router: Router,
              private http: Http,
              private activateRoute: ActivatedRoute,
              private userService: UserService) {

    this.currentUser = {
      password: '',
      passwordconfirm: ''
    };
  }

  ngOnInit() {
  }

  resetPassword() {
    this.showError = false;
    this.errorMessage = '';

    this.password = this.currentUser.password;
    this.passwordconfirm = this.currentUser.passwordconfirm;

    if (!(new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$').test(this.currentUser.password))) {
      this.errorMessage = '* Passwords must contains at least one capital letter one small letter number and special character';
      this.showError = true;
      return;
    }

    if (this.currentUser.password !== this.currentUser.passwordconfirm) {
      this.errorMessage = 'Password and confirm must match';
      this.showError = true;
      return;
    }

    let token = this.activateRoute.snapshot.queryParams['token'];

    return this.userService.resetPassword(this.password, this.passwordconfirm, token)
      .subscribe((result) => {
          this.router.navigate(['/login']);
        },
        err => {
          this.errorMessage = 'The token given is invalid';
          this.showError = true;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts